import { render, staticRenderFns } from "./CDataTable.vue?vue&type=template&id=af39ba1a&scoped=true"
import script from "./CDataTable.vue?vue&type=script&lang=js"
export * from "./CDataTable.vue?vue&type=script&lang=js"
import style0 from "./CDataTable.vue?vue&type=style&index=0&id=af39ba1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af39ba1a",
  null
  
)

export default component.exports